import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Prolongation } from '@/types';
import { useGetProlongationsQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchProlongations<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<Prolongation> } & Omit<
  AutocompleteProps<Prolongation, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetProlongationsQueryProps = useAsyncSearch<Prolongation, Multiple, DisableClearable, FreeSolo>(
    useGetProlongationsQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetProlongationsQueryProps} />;
}

export default SearchProlongations;
